import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconSubtitle16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="subtitle">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 9C3 8.44772 3.44772 8 4 8H12C12.5523 8 13 8.44772 13 9C13 9.55228 12.5523 10 12 10H4C3.44772 10 3 9.55228 3 9Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 3V12H14V3H2ZM1 1C0.447715 1 0 1.52233 0 2.16667V12.8333C0 13.4777 0.447715 14 1 14H15C15.5523 14 16 13.4777 16 12.8333V2.16667C16 1.52233 15.5523 1 15 1H1Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
